export const range = (from, to) => {
  let result = [];
  let n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
};
